import React from "react"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import "./towels-type.scss"
import { datalayerProduct } from "../../../shared/utils/datalayerProducts"
import { withOutScript } from "../../../shared/utils/formatString"
import { removeDoubleSlash } from "../../../shared/utils/urlUril"

const Towelstype = ({ Towelstype, categoria, subcategoria }) => {
  var settings = {
    arrow: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "20%",
    focusOnSelect: true,
  }
  return (
    <div className="f-Towelstype">
      <h2>
        {process.env.LOCALE === "es-PY" ||
        process.env.LOCALE === "es-AR" ||
        process.env.LOCALE === "es-UY"
          ? "¿Conocés los "
          : "¿Conoces los "}
        <span>tipos de toallas?</span>
      </h2>
      <Slider {...settings} className="f-Towelstype-slider">
        {Towelstype.map((info, index) => {
          return (
            <div key={index}>
              <div className="f-Towelstype-slider-item">
                <div>
                  <img
                    alt={info.imagenDelTipoDeToalla.description}
                    src={info.imagenDelTipoDeToalla.file.url}
                  />
                </div>
                <div className="f-Towelstype-slider-item-copy">
                  <h3>{info.titulo}</h3>
                  <p>
                    {info.descripcionDelTipoDeToalla.descripcionDelTipoDeToalla}
                  </p>
                  <div className="f-Towelstype-slider-item-presentations">
                    <div>
                      <p>{info.conoceLasPresentaciones}</p>
                    </div>
                    <div className="f-Towelstype-slider-item-presentations-products">
                      {info.presentacionesDelTipoDeToalla.map(
                        (infoPresentacion, index) => {
                          return (
                            <a
                              href={removeDoubleSlash(`/productos/${categoria}/${subcategoria}/${infoPresentacion.slug}`)}
                              onClick={() => {
                                datalayerProduct({
                                  subCategory: `${withOutScript(categoria)} > ${withOutScript(subcategoria)}`,
                                  label: withOutScript(infoPresentacion.slug),
                                })
                              }}
                              key={index}
                            >
                              <img
                                alt={
                                  infoPresentacion.imagenDelProducto.description
                                }
                                src={
                                  infoPresentacion.imagenDelProducto.file.url
                                }
                              />
                            </a>
                          )
                        }
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        })}
      </Slider>
    </div>
  )
}

export default Towelstype
